import { Navigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { PageTemplate } from '../common/page-template/page-template';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export const RedirectPage = observer(() => {
  const { fileName } = useParams<{ fileName?: string }>();
  const DEFAULT_RATE = 'professional';
  let redirectRoute = `/2/${DEFAULT_RATE}`;

  if (fileName) {
    let cleanFileName = fileName.replace(/\.csv$/i, '');
    cleanFileName = cleanFileName.replace(/ucaas$/i, DEFAULT_RATE);
    redirectRoute = `/2/${cleanFileName}`;
  }

  return <Navigate to={redirectRoute} replace />;
});
